import { useQuery } from '@tanstack/react-query';
import { api } from '../api-client.config';
import { SelectionType } from 'src/types/domain.types';

const getUserSelections = ({
  contestId,
  userId,
}: {
  contestId: number;
  userId: number;
}): Promise<{ selections: SelectionType[] }> =>
  api.get(`/contests/${contestId}/users/${userId}`);

export const useGetUserSelectionsQuery = ({
  contestId,
  userId,
}: {
  contestId: number;
  userId: number;
}) => {
  return useQuery({
    queryKey: ['contests', contestId, 'users', userId],
    queryFn: () => getUserSelections({ contestId, userId }),
    enabled: !!contestId && !!userId,
    select: (data) => data.selections,
  });
};
